import { deepCopy } from "../../app/util";
export const formatCurrency = (currency_symbol, value) => {
    const formateValue = value < 0 ? `-${currency_symbol}${Math.abs(value).toLocaleString()}` : `${currency_symbol}${value.toLocaleString()}`;
    return formateValue;
}

export const dateColTemplate = (dateFormat, notes) => {
    return (settings) => {
        settings.template = null;

        const icon = document.createElement('span');
        icon.classList.add('note-icon-span');
        const data = document.createElement('span');
        data.classList.add('note-data-span');

        //icon.innerHTML = `<svg class="note-icon" style="pointer-events: none" xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="#606060"><g clip-path="url(#C)"><mask id="A" maskUnits="userSpaceOnUse" x="0" y="0" width="8" height="8"><path d="M8 0H0V8H8V0Z" fill="#fff" /></mask><g mask="url(#A)"><mask id="B" maskUnits="userSpaceOnUse" x="0" y="0" width="8" height="8"><path d="M8 0H0V8H8V0Z" fill="#fff" /></mask><g mask="url(#B)"><path opacity=".2" d="M7.333.667V6.14l-1.2 1.193H.667V.667h6.667z" fill="#000" /><path d="M2.667 3h2.667c.187 0 .333-.153.333-.333s-.147-.333-.333-.333H2.667c-.18 0-.333.147-.333.333S2.487 3 2.667 3zm2.667.667H2.667c-.18 0-.333.147-.333.333s.153.333.333.333h2.667c.187 0 .333-.153.333-.333s-.147-.333-.333-.333zM4 5H2.667c-.18 0-.333.147-.333.333s.153.333.333.333H4c.187 0 .333-.153.333-.333S4.187 5 4 5zm3.333-5H.667A.67.67 0 0 0 0 .667v6.667A.67.67 0 0 0 .667 8H5.2a.65.65 0 0 0 .467-.2l.467-.467 1.2-1.193.473-.473A.66.66 0 0 0 8 5.193V.667C8 .3 7.707 0 7.333 0zM5.667 6.86V5.667h1.2l-1.2 1.193zM7.333 5h-2C5.153 5 5 5.147 5 5.333v2H.667V.667h6.667V5zM2.667 3h2.667c.187 0 .333-.153.333-.333s-.147-.333-.333-.333H2.667c-.18 0-.333.147-.333.333S2.487 3 2.667 3zm0 1.333h2.667c.187 0 .333-.153.333-.333s-.147-.333-.333-.333H2.667c-.18 0-.333.147-.333.333s.153.333.333.333zm0 1.333H4c.187 0 .333-.153.333-.333S4.187 5 4 5H2.667c-.18 0-.333.147-.333.333s.153.333.333.333zM4 5H2.667c-.18 0-.333.147-.333.333s.153.333.333.333H4c.187 0 .333-.153.333-.333S4.187 5 4 5zm1.333-1.333H2.667c-.18 0-.333.147-.333.333s.153.333.333.333h2.667c.187 0 .333-.153.333-.333s-.147-.333-.333-.333zm0-1.333H2.667c-.18 0-.333.147-.333.333S2.487 3 2.667 3h2.667c.187 0 .333-.153.333-.333s-.147-.333-.333-.333z" fill="#606060" /></g></g></g><defs><clipPath id="C"><path fill="#fff" d="M0 0h8v8H0z" /></clipPath></defs></svg>`
        icon.innerHTML = `<svg class="note-icon" style="pointer-events: none" xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#606060" viewBox="0 0 256 256"><path d="M88,96a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H96A8,8,0,0,1,88,96Zm8,40h64a8,8,0,0,0,0-16H96a8,8,0,0,0,0,16Zm32,16H96a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM224,48V156.69A15.86,15.86,0,0,1,219.31,168L168,219.31A15.86,15.86,0,0,1,156.69,224H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM48,208H152V160a8,8,0,0,1,8-8h48V48H48Zm120-40v28.7L196.69,168Z"></path></svg>`
        data.innerHTML = `<span class="date">${dateFormat(settings.row.data.date, "MMM DD")}</span>`

        let template = document.createElement('div');
        template.className = 'note-column-data';

        const dataForDate = notes !== undefined ? notes.find(item => item.stay_date === settings.row.data.date) : undefined;

        if (dataForDate && dataForDate.note) {
            template.appendChild(icon);
        }

        template.appendChild(data);

        settings.template = template;

    }
}

export const dowColTemplate = (dateFormat, avgImpactData, getDemandImpactColor, eventList, isDateInRange) => {
    return (settings) => {
        settings.template = null;

        const icon = document.createElement('span');
        icon.classList.add('event-icon-span');
        const data = document.createElement('span');
        data.classList.add('event-data-span');
        data.classList.add('events-column-data-dow');


        const avgImpactDataForStayDate = avgImpactData && avgImpactData.find(item => item.date === settings.row.data.date);
        const avgImpactColor = avgImpactDataForStayDate !== undefined ? getDemandImpactColor(avgImpactDataForStayDate.demand_impact) : "transparent";
        const filteredEventList = eventList.filter(event =>
            isDateInRange(settings.row.data.date, event.start_date, event.end_date) && event.is_ignored === false
        );

        icon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill=${avgImpactColor} style="pointer-events: none" viewBox="0 0 256 256">
                <path d="M246.66,132.44,201,200.88A16,16,0,0,1,187.72,208H32a8,8,0,0,1-6.66-12.44L70.39,128l-45-67.56A8,8,0,0,1,32,48H187.72A16,16,0,0,1,201,55.12l45.63,68.44A8,8,0,0,1,246.66,132.44Z"></path>
            </svg>`
        data.innerHTML = `<span class="date">${dateFormat(settings.row.data.date, "ddd")}</span>`

        let template = document.createElement('div');
        template.className = 'events-column-data';

        if (filteredEventList.length !== 0) {
            template.appendChild(icon);
        }

        template.appendChild(data);

        settings.template = template;

    }
}

export const requiredColTemplate = (templateClass = '') => {
    return (settings) => {
        const dataField = settings.column.dataField;
        const value = settings.row.data[dataField];


        settings.template = null;

        const copyBtn = document.createElement('button');
        copyBtn.classList.add('copy-btn');
        const data = document.createElement('span');
        data.classList.add('cell-data-span');

        copyBtn.innerHTML = `<svg width="11" height="11" style="pointer-events: none" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_621_1429)">
                    <path d="M9.58333 0H2.91667C2.80616 0 2.70021 0.0438895 2.62207 0.12203C2.54393 0.20017 2.5 0.30616 2.5 0.416667V2.5H0.416667C0.30616 2.5 0.20021 2.54389 0.12207 2.62203C0.0439302 2.70017 0 2.80616 0 2.91667V9.58333C0 9.69384 0.0439302 9.79981 0.12207 9.87795C0.20021 9.95609 0.30616 10 0.416667 10H7.08333C7.19384 10 7.29983 9.95609 7.37797 9.87795C7.45611 9.79981 7.5 9.69384 7.5 9.58333V7.5H9.58333C9.69384 7.5 9.79983 7.45609 9.87797 7.37795C9.95611 7.29981 10 7.19384 10 7.08333V0.416667C10 0.30616 9.95611 0.20017 9.87797 0.12203C9.79983 0.0438895 9.69384 0 9.58333 0ZM6.66667 9.16667H0.833333V3.33333H6.66667V9.16667ZM9.16667 6.66667H7.5V2.91667C7.5 2.80616 7.45611 2.70017 7.37797 2.62203C7.29983 2.54389 7.19384 2.5 7.08333 2.5H3.33468V0.833333H9.16801L9.16667 6.66667Z" fill="#606060" />
                    <path d="M5.1786 6.43131C5.11609 6.36882 5.03135 6.33372 4.94297 6.33372C4.85458 6.33372 4.7698 6.36882 4.70729 6.43131L4.08326 7.05597V4.63997C4.08326 4.55157 4.04816 4.46679 3.98565 4.40428C3.92314 4.34176 3.83834 4.30664 3.74993 4.30664C3.66153 4.30664 3.57677 4.34176 3.51425 4.40428C3.45174 4.46679 3.4166 4.55157 3.4166 4.63997V7.05597L2.79196 6.43131C2.7291 6.3706 2.64487 6.33699 2.55747 6.33775C2.47007 6.33851 2.38648 6.37356 2.32468 6.43536C2.26288 6.49717 2.22782 6.58077 2.22706 6.66817C2.2263 6.75557 2.25989 6.83978 2.32061 6.90265L3.51393 8.09597C3.56058 8.14256 3.62003 8.17428 3.68471 8.18709C3.74938 8.19991 3.8164 8.19324 3.87729 8.16797C3.9179 8.15135 3.9548 8.12689 3.98593 8.09597L5.1786 6.90265C5.24109 6.84014 5.27622 6.75536 5.27622 6.66697C5.27622 6.57858 5.24109 6.49382 5.1786 6.43131Z" fill="#606060" />
                </g>
                <defs>
                    <clipPath id="clip0_621_1429">
                        <rect width="12" height="12" fill="white" />
                    </clipPath>
                </defs>
            </svg>`;

        data.innerHTML = value.toLocaleString();

        let template = document.createElement('div');
        template.className = `input-column-data ${templateClass}`;

        template.appendChild(copyBtn);
        template.appendChild(data);

        settings.template = template;
    }
}

export const viewCurrencyTemplate = (currency_symbol, formatCurrency, templateClass = '') => {
    return (settings) => {
        const dataField = settings.column.dataField;
        const value = isNaN(settings.row.data[dataField]) ? 0 : Number(settings.row.data[dataField]);

        const data = document.createElement('span');
        data.classList.add('cell-data-span');

        data.innerHTML = `${formatCurrency(currency_symbol, value)}`;

        let template = document.createElement('div');
        template.className = `${templateClass}`;

        template.appendChild(data);

        settings.template = template;

    }

}

export const copyCurrencyTemplate = (currency_symbol, formatCurrency, templateClass = '') => {
    return (settings) => {
        const dataField = settings.column.dataField;
        const value = isNaN(settings.row.data[dataField]) ? 0 : Number(settings.row.data[dataField]);

        const copyBtn = document.createElement('button');
        copyBtn.classList.add('copy-btn');
        const data = document.createElement('span');
        data.classList.add('cell-data-span');

        copyBtn.innerHTML = `<svg width="11" height="11" style="pointer-events: none" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_621_1429)">
                    <path d="M9.58333 0H2.91667C2.80616 0 2.70021 0.0438895 2.62207 0.12203C2.54393 0.20017 2.5 0.30616 2.5 0.416667V2.5H0.416667C0.30616 2.5 0.20021 2.54389 0.12207 2.62203C0.0439302 2.70017 0 2.80616 0 2.91667V9.58333C0 9.69384 0.0439302 9.79981 0.12207 9.87795C0.20021 9.95609 0.30616 10 0.416667 10H7.08333C7.19384 10 7.29983 9.95609 7.37797 9.87795C7.45611 9.79981 7.5 9.69384 7.5 9.58333V7.5H9.58333C9.69384 7.5 9.79983 7.45609 9.87797 7.37795C9.95611 7.29981 10 7.19384 10 7.08333V0.416667C10 0.30616 9.95611 0.20017 9.87797 0.12203C9.79983 0.0438895 9.69384 0 9.58333 0ZM6.66667 9.16667H0.833333V3.33333H6.66667V9.16667ZM9.16667 6.66667H7.5V2.91667C7.5 2.80616 7.45611 2.70017 7.37797 2.62203C7.29983 2.54389 7.19384 2.5 7.08333 2.5H3.33468V0.833333H9.16801L9.16667 6.66667Z" fill="#606060" />
                    <path d="M5.1786 6.43131C5.11609 6.36882 5.03135 6.33372 4.94297 6.33372C4.85458 6.33372 4.7698 6.36882 4.70729 6.43131L4.08326 7.05597V4.63997C4.08326 4.55157 4.04816 4.46679 3.98565 4.40428C3.92314 4.34176 3.83834 4.30664 3.74993 4.30664C3.66153 4.30664 3.57677 4.34176 3.51425 4.40428C3.45174 4.46679 3.4166 4.55157 3.4166 4.63997V7.05597L2.79196 6.43131C2.7291 6.3706 2.64487 6.33699 2.55747 6.33775C2.47007 6.33851 2.38648 6.37356 2.32468 6.43536C2.26288 6.49717 2.22782 6.58077 2.22706 6.66817C2.2263 6.75557 2.25989 6.83978 2.32061 6.90265L3.51393 8.09597C3.56058 8.14256 3.62003 8.17428 3.68471 8.18709C3.74938 8.19991 3.8164 8.19324 3.87729 8.16797C3.9179 8.15135 3.9548 8.12689 3.98593 8.09597L5.1786 6.90265C5.24109 6.84014 5.27622 6.75536 5.27622 6.66697C5.27622 6.57858 5.24109 6.49382 5.1786 6.43131Z" fill="#606060" />
                </g>
                <defs>
                    <clipPath id="clip0_621_1429">
                        <rect width="12" height="12" fill="white" />
                    </clipPath>
                </defs>
            </svg>`;
        data.innerHTML = `${formatCurrency(currency_symbol, value)}`;

        let template = document.createElement('div');
        template.className = `input-column-data ${templateClass}`;

        template.appendChild(copyBtn);
        template.appendChild(data);

        settings.template = template;
    }
}

export const editCurrencyTemplate = (currency_symbol, formatCurrency, templateClass = '') => {
    return (settings) => {
        const dataField = settings.column.dataField;
        const value = isNaN(settings.row.data[dataField]) ? 0 : Number(settings.row.data[dataField]);

        const data = document.createElement('span');
        data.classList.add('cell-data-span');

        data.innerHTML = `${formatCurrency(currency_symbol, value)}`;

        let template = document.createElement('div');
        template.className = `input-column-data ${templateClass}`;

        template.appendChild(data);

        settings.template = template;
    }
}


export const viewPercentageTemplate = (templateClass = '') => {
    return (settings) => {
        const dataField = settings.column.dataField;
        const value = isNaN(settings.row.data[dataField]) ? 0 : Number(settings.row.data[dataField]);

        const data = document.createElement('span');
        data.classList.add('cell-data-span');

        data.innerHTML = `${parseFloat((value * 100).toFixed(2))}%`;

        let template = document.createElement('div');
        template.className = `${templateClass}`;

        template.appendChild(data);

        settings.template = template;

    }

}

export const getBarSellRate = (datesData, rateType = 'wish') => {
    const totalObj = {};

    datesData[0][rateType].forEach((item, index) => {
        let roomType = item.room_type;
        let bar_sell_rate = [];
        let dates = [];
        let bar_sell_rate_total = 0;
        totalObj[roomType] = { dates, bar_sell_rate, bar_sell_rate_total };
    })

    datesData.forEach((entry, index) => {
        entry[rateType].forEach(item => {
            totalObj[item.room_type].dates.push(entry.date);
            let value = item.rooms === 0 ? 0 : item.bar_sell_rate;
            totalObj[item.room_type].bar_sell_rate.push(value);
            totalObj[item.room_type].bar_sell_rate_total += value;
        })
    })

    const barSellRateTotal = deepCopy(totalObj);
    return barSellRateTotal;
};

export const formatNumberTemplate = () => {
    return (settings) => {
        const dataField = settings.column.dataField;
        const value = isNaN(settings.row.data[dataField]) ? 0 : Number(settings.row.data[dataField]);

        const data = document.createElement('span');
        data.classList.add('cell-data-span');

        data.innerHTML = value.toLocaleString();

        let template = document.createElement('div');

        template.appendChild(data);

        settings.template = template;
    }
}